<template>
  <div class="activityOrder">
    <div class="container" v-if="isshow">
      <div class="content">
        <el-steps
          class="second-menu"
          :active="secondMenu.active"
          finish-status="success"
          space="100px"
          align-center
        >
          <el-step
            v-for="(item,index) in secondMenu.list"
            :key="index"
            :title="item"
            @click.native="getType(index + 1)"
          ></el-step>
        </el-steps>
        <div class="list">
          <div class="useractivity" v-loading="loading" v-if="secondMenu.active!=6">
            <div class="useritem" v-for="(item,index) in kindList" :key="index" >
              <div class="img">
                <img :src="item.linePic" class="act-img" />
              </div>
              <div class="user-right">
                <div class="toporder">
                  <span class="order">订单号：{{item.sn}}</span>
                  <span
                    class="complete"
                    :class="[status(item) === '已过期' ? 'grey' : '']"
                  >{{status(item)}}</span>
                </div>

                <span class="title">
                  <b v-if="item.line && item.line.lineTitile">{{item.line.lineTitile}}</b>
                </span>
                <div class="act-title">
                  <span>{{item.associatename}}</span>
                  <span>
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    {{formatTimeDate(item.lineSchedule.departDate)}} 出发
                  </span>
                </div>
                <div class="toporder">
                  <span class="orderprice">
                    <span class="red">￥{{item.paymentAmount}}</span>
                    <!-- <span class="mount">X1</span> -->
                  </span>
                  <span class="date">{{formatTimeDate(item.createDate)}}</span>
                </div>
                <!-- <p class="userdescribe">想要躲避都市的喧嚣？想享尽情吸氧？想寻幽探秘、玩赏奇特美景？想来点不一样的，玩转无聊假期？今天给你的推挤都能满足</p> -->
                <div class="bottom-infos">
                  <!-- <el-radio-group
                    v-model="item.payMethod"
                    v-if="secondMenu.active === 1&&item.isexpiry===0"
                  >
                    <el-radio
                      v-for="(item,index) in payMethodArray"
                      :key="index"
                      :label="index"
                    >{{item}}</el-radio>
                  </el-radio-group> -->
                  <span
                    class="mores"
                    @click="toPayorRefund(item.sn,item.id,item.paymentAmount,item.payMethod,item.signUpStatus)"
                    v-show="secondMenu.active === 1&&item.isexpiry===0"
                  >立刻支付</span>
                  <span
                    class="mores"
                    @click="toServiceAgreement(item.signature.id)"
                    v-show="(secondMenu.active === 2 || secondMenu.active === 3) && item.signature && item.signature.id"
                  >查看协议</span>
                  <span
                    class="mores"
                    @click="toPayorRefund(item.sn,item.id,item.paymentAmount,item.payMethod,item.signUpStatus)"
                    v-show="secondMenu.active === 2&&item.isSupportRefund===1&&item.orderStatus!='refunding'"
                  >退款</span>
                  <span
                    class="mores"
                    @click="openEvaluate(item.id,item.line.lineTitile,item.linePic)"
                    v-show="secondMenu.active === 5"
                  >去评价</span>
                  <span
                    class="mores"
                    @click="cancelRefunt(item.id)"
                    v-show="secondMenu.active === 2&&item.orderStatus=='refunding'"
                  >取消退款</span>
                  <!-- <span
                    class="mores"
                    @click="toPayorRefund(item.sn,item.id,item.amount,item.payMethod,item.signUpStatus)"
                    v-show="secondMenu.active === 1 || secondMenu.active === 2"
                  >{{ secondMenu.active === 1 ? '立刻支付' : '退款' }}</span>-->
                  <span
                    class="delete"
                    v-show="secondMenu.active === 1"
                    @click="toDelete(item.sn,index)"
                  >删除订单</span>
                  <span
                    class="mores"
                    v-show="secondMenu.active === 4"
                    @click="getRundDetail(item.sn)"
                  >退款详情</span>
                </div>
              </div>
            </div>

          </div>
          <div class="useractivity completed-evaluted-list" v-loading="loading" v-if="secondMenu.active==6">
            <div class="useritem" v-for="(item,index) in kindList" :key="index" >
              <div class="img">
                <img :src="item.lineImage" class="act-img" />
              </div>
              <div class="user-right">
                <!-- <div class="toporder">
                  <span class="order">订单号：{{item.sn}}</span>
                  <span
                    class="complete"
                    :class="[status(item) === '已过期' ? 'grey' : '']"
                  >{{status(item)}}</span>
                </div> -->
                <span class="title">
                  <b v-if="item.lineTitle">{{item.lineTitle}}</b>
                </span>
                <span class="depart-time">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    出发日期:{{fomateDate2(item.departDate)}} 
                </span>
                <div class="star-wrapper">
                  <div class="score line-score">
                    <div class="label">线路评分：</div>
                        <el-rate
                          v-model="item.lineScore"
                          disabled
                          :colors="['#FF7E00', '#FF7E00', '#FF7E00']"
                          >
                      </el-rate>
                  </div>
                  <div class="score leader-score">
                    <div class="lable">领队评分：</div>
                        <el-rate
                          v-model="item.leaderScore"
                          disabled
                          :colors="['#FF7E00', '#FF7E00', '#FF7E00']"
                          >
                      </el-rate>
                  </div>
                </div>
                <div class="text">{{ item.comment }}</div>
                    <div class="comment-images-out">
                      <image-preview-list v-if="item.image" :height="70" :width="70" :picList="item.image" />
                    </div> 
                <div
                    class="seller-reply"
                    v-if="item.evaluateReply"
                  >官方回复:<span class="main"> {{item.evaluateReply}}</span></div>
                <div class="act-title-empty">
                  
                </div>
                <div class="act-title">
                  <span>{{item.associatename}}</span>
                  <span>
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    评价日期:{{formatTimeDate(item.createDate)}} 
                  </span>
                </div>
                <!-- <div class="toporder">
                  <span class="orderprice">
                    <span class="red">￥{{item.paymentAmount}}</span>
                  </span>
                  <span class="date">{{formatTimeDate(item.createDate)}}</span>
                </div> -->
              </div>
            </div>

          </div>
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              @prev-click="prevClick"
              @next-click="nextClick"
              @current-change="handleCurrentChange"
              :page-size="10"
              :page-count="pageCount"
              :current-page="typeCurrentPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <wxpay
      :open="wxpayDialog"
      :src="wxpaysrc"
      :wechatamount="wechatamount"
      @close="closeWxpay"
      :method="payMethod"
    ></wxpay>

    <el-dialog class="my-dialog" :visible.sync="dialogVisible" width="40%">
      <div slot="title" class="title">退款</div>
      <div class="table">
        <div class="th tr">
          <div
            class="td all-click"
            @click="handleAllClick"
            :class="[ allChecked ? 'isActive' : '' ]"
          >{{allChecked ? '全选' : '不选'}}</div>
          <div class="td" v-for="(item,index) in dialogTitles" :key="index">{{item}}</div>
        </div>
        <div class="tr" v-for="(item,index) in refund.list" :key="index">
          <div class="td">
            <el-checkbox
              v-model="checkedArr[index]"
              class="td"
              @change="handleCheckboxClick"
              v-show="item.refundstatus===''"
            />
          </div>
          <div class="td name">{{item.signUpName}}</div>
          <div class="td count">￥{{item.amount}}</div>
          <div class="td status">
            <div class="box">{{getRefundstatus(item.refundstatus)}}</div>
          </div>
        </div>
      </div>
      <div class="dialog-bottom">
        <div @click="toRefund" :class="[caniRefund ? 'no-refund' : '']">退款</div>
      </div>
    </el-dialog>
    <el-dialog title="退款详情" class="my-dialog" :visible.sync="isshowrefund" width="40%">
      <div class="right">
        <div class="item">
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          <span class="text">订单号：{{refundsn}}</span>
        </div>

        <div class="item">
          <i class="fa fa-clock-o" aria-hidden="true"></i>
          <span class="text">订单时间：{{timeFormat(refundorder.createDate)}}</span>
        </div>
        <div class="item">
          <i class="fa fa-clock-o" aria-hidden="true"></i>
          <span class="text">退款时间：{{timeFormat(refundorder.modifyDate)}}</span>
        </div>
        <div class="item">
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          <span class="text">
            订单状态：
            <span class="col">已退款</span>
          </span>
        </div>
        <div class="item">
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          <span class="text">付款金额：￥{{refundorder.paymentAmount}}</span>
        </div>
        <div class="item">
          <i class="fa fa-file-text-o" aria-hidden="true"></i>
          <span class="text">退款金额：￥{{refundamout}}</span>
        </div>
        <div class="item">
          <i class="fa fa-database" aria-hidden="true"></i>
          <span class="text">
            退款方式：
            <span class="col-red">已按原支付方式退回</span>
          </span>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="发表评价" class="my-dialog" :visible.sync="isshowEvalute" width="1000px">
      <div class="evalute">
        <div class="top-wrapper">
          <img :src="evaluateForm.linePic" alt />
          <div class="title">{{ evaluateForm.lineTitle }}</div>
     </div>
     <div class="item">
      <div class="score-wrapper">
          <div class="label">线路评分</div>
          <div class="star">
            <el-rate
                v-model="evaluateForm.lineScore"
                :colors="['#FF7E00', '#FF7E00', '#FF7E00']"
            >
           </el-rate>  
        </div>
     </div>
      <div class="score-wrapper">
          <div class="label">领队评分</div>
          <div class="star">
            <el-rate
                v-model="evaluateForm.leaderScore"
                :colors="['#FF7E00', '#FF7E00', '#FF7E00']"
            >
           </el-rate>  
        </div>
     </div>
    </div>
     <div class="item">
     <div class="edit-wrapper">
      <div class="label">评价</div>
      <el-input type="textarea" placeholder="亲，写下你的旅游体会来帮助其他的小伙伴们" :rows="5" v-model.trim="evaluateForm.comment"></el-input>

      </div>
    </div>
      <div class="item">
        <div class="upload-wrapper">
          <div class="label">评价图片</div>
          <image-upload v-model="uploadPaths" :limit="9" ref="ImgUpload"/>
        </div>
      </div>
      <div class="footer-btn" @click="submitEvaluate">提交评价 </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import { formatTimeDate, timeFormat,fomateDate2 } from "@/util/util.js";
import ImageUpload from "@/components/comment/ImageUpload.vue";
import ImagePreviewList from "@/components/comment/ImagePreviewList.vue";
import wxpay from "../wxpay/index.vue";
const LENGTH = 5;
const CLS_ON = "on";
const CLS_HALF = "half";
const CLS_OFF = "off";
export default {
  name: "activityOrder",
  data() {
    return {
      isshowrefund: false,
      refundorder: "",
      refundline: "",
      uploadPaths: [],
      refundamout: "",
      refundsn: "",
      pageNumber: 1,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      secondMenu: {
        active: 1,
        activeType: "pay",
        list: ["待支付", "待出发", "已结束", "已退款","待评价","已评价"],
      },
      isshow: true,
      dialogVisible: false,
      dialogTitles: ["姓名", "金额", "状态"],
      allChecked: false,
      checkedArr: [],
      //订单列表
      orderList: {
        pay: {
          currentPage: 1, //当前分页器页码
          page: 0, //当前已请求的总页数
          total: 0, //总条目
          totalpage: 0, //总页数
          dataList: [], //该类型的数据列表
        },
        go: {
          currentPage: 1,
          page: 0,
          total: 0,
          totalpage: 0,
          dataList: [],
        },
        finished: {
          currentPage: 1,
          page: 0,
          total: 0,
          totalpage: 0,
          dataList: [],
        },
        refund: {
          currentPage: 1,
          page: 0,
          total: 0,
          totalpage: 0,
          dataList: [],
        },
        toBeEvaluate: {
          currentPage: 1,
          page: 0,
          total: 0,
          totalpage: 0,
          dataList: [],
        },
        completeEvaluate: {
          currentPage: 1,
          page: 0,
          total: 0,
          totalpage: 0,
          dataList: [],
        },
      },

      //退款列表
      refund: {
        orderId: null,
        list: [],
      },
      isshowEvalute:false,
      evaluateForm:{},
      //微信支付弹框
      wxpayDialog: false,
      wxpaysrc: "",
      wechatamount: 0,

      //支付方式:
      payMethodArray: ["微信", "支付宝"],
      payMethod: 0, //0微信 , 1支付宝

      loading: false,
    };
  },
  components: {
    wxpay,ImageUpload,ImagePreviewList
  },
  computed: {
    // payMethod(item){
    //   return (item) => { //给item创建payMethod，等待修改
    //     item.payMethod = 0;
    //     return item.payMethod;
    //   }
    // },
    pageCount() {
      const length = this.orderList[this.secondMenu.activeType].dataList.length;
      return length >= 10
        ? this.orderList[this.secondMenu.activeType].page + 1
        : 1;
    },
    kindList() {
      const type = this.secondMenu.activeType;
      const currentPage = this.orderList[type].currentPage;
      const dataList = this.orderList[type].dataList;
      const kindList = dataList.slice((currentPage - 1) * 10, currentPage * 10);

      return kindList;
    },
    typeCurrentPage() {
      return this.orderList[this.secondMenu.activeType].currentPage;
    },
    total() {
      return this.orderList[this.secondMenu.activeType].total;
    },
    status(item) {
      return function (item) {
        let arr = "";
        if (this.secondMenu.active == 1 && item.isexpiry === 1) {
          arr = "已过期";
        }else if(this.secondMenu.active == 1 && item.isexpiry === 0){
           arr = "待支付";
        }else if (
          this.secondMenu.active == 2 &&
          item.orderStatus == "confirmed"
        ) {
          arr = "已支付";
        }else if (
          this.secondMenu.active == 2 &&
          item.orderStatus == "returngood"
        ) {
          arr = "已退款";
        } else if (
          this.secondMenu.active == 2 &&
          item.orderStatus == "refunding"
        ) {
          arr = "退款中";
        } else if (this.secondMenu.active == 3) {
          arr = "已结束";
        } else if (this.secondMenu.active == 4) {
          arr = "已退款";
        } else if (this.secondMenu.active == 5) {
          arr = "待评价";
        }else if (this.secondMenu.active == 6) {
          arr = "已评价";
        }
        return arr
        // const arr = ["待支付", "待出发", "已结束", "已退款"];
        // return this.secondMenu.active - 1 === 0 && item.isexpiry === 1
        //   ? "已过期"
        //   : arr[this.secondMenu.active - 1];
      };
    },
    // 提交评价
    doEvaluate(){

    },
    getRefundstatus() {
      return function (num) {
        switch (num) {
          case 0:
            return "审核中";
            break;
          case 1:
            return "已退款";
            break;
          case -1:
            return "不通过";
            break;
          default:
            return "未退款";
            break;
        }
      };
    },
    caniRefund() {
      for (let item of this.refund.list) {
        if (item.refundstatus !== 1 && item.refundstatus !== 0) {
          //如果存在无申请状态
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    formatTimeDate,
    timeFormat,
    fomateDate2,
    // 去协议页
    toServiceAgreement(signatureId){
      this.$router.push({
        path: `/serviceAgreement`,
        query: { signatureId: signatureId },
      });
    },
    // 打开评价
    openEvaluate(orderId,lineTitle,linePic){
      this.isshowEvalute = true;
      this.evaluateForm = {
          orderId: orderId,
          lineTitle: lineTitle,
          linePic: linePic,
          comment:'',
          leaderScore:5,
          lineScore:5,
          image:"",
      }
      this.uploadPaths = "";
      console.log(" this.evaluateForm", this.evaluateForm);
    },
    // 提交评价
    submitEvaluate(){
      let image = "";
      const fileList = this.$refs.ImgUpload.fileList;
      if(fileList.length>9){
        this.$message({
              message: "最多只允许上传9张图片",
              type: "warning",
              duration: 3000,
              center: true,
            });
            return;
      }
      if(fileList&&fileList.length>0){
        fileList.forEach(file => {
          if(image!=""){
            image += "," + file.url;
          }else{
            image = file.url;
          }
        });
      }
      let params = {
        image:image,
        comment:this.evaluateForm.comment,
        lineScore:this.evaluateForm.lineScore,
        leaderScore:this.evaluateForm.leaderScore,
        orderId:this.evaluateForm.orderId
      }; 
      this.loading = true;
      axios
        .post("/mobile/line_evaluate/createEvaluate.jhtml", qs.stringify(params))       
         .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.$message({
              message: "提交评价成功",
              type: "success",
              duration: 3000,
              center: true,
            });
            this.isshowEvalute = false;
            setTimeout(() => {
              this.$router.go(0);
            }, 1500);
          } else {
            this.$message({
              message: res.data.errorReason,
              duration: 3000,
              type: "warning",
              center: true,
            });
          }
        });
    },
    cancelRefunt(id) {
      let params = {
        orderId: id,
      };
      axios
        .post(`/refund/cancelRefund.jhtml`, qs.stringify(params))
        .then((res) => {
          if (res.data.success) {
            this.requestOrderMessage("go");
            this.$message("撤销成功");
            // this.$vux.toast.text("撤销成功~", "middle");
          } else {
            this.$message(res.data.errorReason);
            // this.$vux.toast.text(res.data.errorReason, "middle");
          }
        });
    },
    getRundDetail(sn) {
      this.refundsn = sn;
      axios
        .get("/order/findrefundByOrder.jhtml", {
          params: {
            sn: sn,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.refundline = res.data.returnValue.line;
            this.refundorder = res.data.returnValue.order;
            this.refundamout = res.data.returnValue.refundamout;
            this.isshowrefund = true;
          } else {
          }
        })
        .catch((e) => {});
    },
    closeWxpay() {
      this.wxpayDialog = false;
    },
    toRefund() {
      const orderId = this.refund.orderId;
      const refundList = this.refund.list;
      let rosters = [];
      let rosterslist = {};
      let total = 0;
      for (let index = 0; index < this.checkedArr.length; index++) {
        if (
          this.checkedArr[index] &&
          refundList[index].refundstatus !== 1 &&
          refundList[index].refundstatus !== 0
        ) {
          let rostersitem = {};
          rostersitem.signUpId = refundList[index].id;
          rosters.push(rostersitem);
          total += refundList[index].amount;
          //选中并且是没申请状态
          // this.toServerRefund(
          //   orderId,
          //   refundList[index].id,
          //   refundList[index].amount
          // );
        }
      }
      rosterslist.rosters = rosters;
      console.log(rosterslist);
      console.log(total);
      let params = {
        orderId: orderId,
        rosters: JSON.stringify(rosterslist),
        refundAmout: total,
      };
      axios
        .post(`/refund/createRefund.jhtml`, qs.stringify(params))
        .then((res) => {
          if (res.data.success) {
            this.dialogVisible = false;
            this.checkedArr = [];

            this.$message("申请成功，等待审核中~");
            setTimeout(() => {
              this.$router.go(0);
            }, 1500);
          } else {
            this.$message(res.data.errorReason);
          }
        });
    },
    toServerRefund(orderId, signId, refundAmout) {
      axios
        .post(
          "/refund/orderRefund.jhtml",
          qs.stringify({
            orderId: orderId,
            signId: signId,
            refundAmout: refundAmout,
          })
        )
        .then((res) => {
          if (res.data.success) {
            // console.log(res.data);
          }
        });
    },
    handleCheckboxClick() {
      for (let i = 0; i < this.refund.list.length; i++) {
        if (this.checkedArr[i] ? false : true) {
          this.allChecked = false;
          return;
        }
      }
      this.allChecked = true;
    },
    handleAllClick() {
      this.allChecked = !this.allChecked;
      for (let i = 0; i < this.refund.list.length; i++) {
        this.checkedArr[i] = this.allChecked;
      }
    },
    // goWxpay(sn) {
    //   // this.wechatamount = buy.amount;
    //   const url = this.payMethod
    //     ? "/payment/alipay.jhtml"
    //     : "/payment/h5wechatpay.jhtml";

    //   axios
    //     .get(
    //       url,
    //       {
    //         params: {
    //           sn: sn,
    //         },
    //       },
    //       {
    //         responseType: "blob",
    //       }
    //     )
    //     .then(async (res) => {
    //       if (res.data.success) {
    //         // 设置一个定时器
    //         this.checkWxpay(sn);
    //         try {
    //           //  this.wxpaysrc = await this.blobToDataURL(res.data.returnValue);
    //           this.wxpaysrc = this.payMethod
    //             ? res.data.returnValue.payinfo
    //             : res.data.returnValue;
    //           this.wxpayDialog = true;
    //         } catch (error) {
    //           console.log(error);
    //         }
    //       } else {
    //         this.$message(res.data.errorReason);
    //       }
    //     });
    // },
    //wx支付 / 支付宝支付
     goWxpay(sn) {
       // 设置一个定时器
       this.checkWxpay(sn);
          try {
            this.wxpaysrc = "https://www.1778hw.com/m/pcCheckstand?"+"sn="+sn;
            console.log("this.wxpaysrc",this.wxpaysrc)
            this.wxpayDialog = true;
          } catch (error) {
            console.log(error);
       }
    },
    checkWxpay(sn) {
      axios
        .get("/payment/pc/notify.jhtml", {
          params: {
            sn: sn,
          },
        })
        .then((res) => {
          if (res.data.type === "error") {
            if (this.wxpayDialog) {
              const timer = setTimeout(() => {
                this.checkWxpay(sn);
                clearTimeout(timer);
              }, 3000);
            }
          } else {
            this.wxpayDialog = false;
            this.$message({
              type: "success",
              duration: 2000,
              message: "支付成功",
            });
            // this.requestOrderMessage();
          }
        });
    },
    toPayorRefund(sn, orderId, amount, method, signUpStatus) {
      if (this.secondMenu.active === 1) {
        if (signUpStatus === "已满员") {
          this.$message({
            type: "warning",
            duration: 1500,
            message: "抱歉，活动已满员",
          });
        } else {
          this.wechatamount = amount;
          this.payMethod = method;
        }

        this.goWxpay(sn);
      } else if (this.secondMenu.active === 2) {
        this.dialogVisible = true;

        //请求相关报名表
        this.requestRefundList(sn, orderId);
      }
    },
    requestRefundList(sn, orderId) {
      axios
        .get("/order/findSignByOrder.jhtml", {
          params: {
            sn: sn,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.refund.list = res.data.returnValue;
            this.refund.orderId = orderId;
          }
        });
    },
    toDelete(sn, index) {
      axios
        .get("/order/cancel.jhtml", {
          params: {
            sn: sn,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            const type = this.secondMenu.activeType;
            const message = this.orderList[type].dataList.splice(
              index,
              index + 1
            );

            this.$message({
              type: "success",
              message: "删除订单成功",
              duration: 1000,
            });
          }
        });
    },
    handleCurrentChange(val) {
      // this.orderList.currentPage = val;
      const type = this.secondMenu.activeType;
      let currentPage = this.orderList[type].currentPage;
      const page = this.orderList[type].page;
      const totalpage = this.orderList[type].totalpage;
      this.orderList[type].currentPage = val;
      if (this.orderList[type].currentPage - 1 >= page && page < totalpage) {
        this.loading = true;
        this.requestOrderMessage(type);
      }
    },
    requestOrderMessage(category) {
      let params = {
        pageSize: 10,
        pageNumber: this.orderList[category].page + 1,
      };
      switch (category) {
        case "pay":
          params.orderStatus = 0;
          params.paymentStatus = 0;
          break;

        case "go":
          params.type = 0;
          break;

        case "finished":
          params.type = 1;
          break;

        case "refund":
          params.orderStatus = 5;
          params.paymentStatus = 4;
          break;

        default:
          break;
      }

      let url =
        category.indexOf("pay") !== -1 || category.indexOf("refund") !== -1
          ? `/order/myOrder.jhtml`
          : "/order/myOrdersecond.jhtml";
      if(category.indexOf("toBeEvaluate") !== -1 ){
         url = "/mobile/line_evaluate/toBeEvaluateOrder.jhtml" 
      }else if(category.indexOf("completeEvaluate") !== -1){
        url = "/mobile/line_evaluate/completeEvaluateOrder.jhtml" 
      }
      axios
        .get(url, {
          params,
        })
        .then((res) => {
          if (res.data.success) {
            const data = res.data.returnValue;
            this.orderList[category].total = data.total;
            this.orderList[category].totalpage = data.totalpage;

            let newList = null;
            if (this.secondMenu.active === 1 && data.data) {
              newList = data.data.map((item) => {
                item.payMethod = 0;
                return item;
              });
            } else {
              newList = data.data;
            }

            this.orderList[category].dataList.push(...newList);
            if (data.data.length > 0) {
              this.orderList[category].page += 1;
            }
            this.loading = false;
          }
        });
    },
    prevClick() {
      let currentPage = this.orderList[this.secondMenu.activeType].currentPage;
      if (currentPage > 1) {
        this.orderList[this.secondMenu.activeType].currentPage -= 1;
      }
    },
    nextClick() {
      const type = this.secondMenu.activeType;
      let currentPage = this.orderList[type].currentPage;
      const page = this.orderList[type].page;
      const totalpage = this.orderList[type].totalpage;
      if (currentPage < totalpage) {
        // this.orderList[type].currentPage += 1; //使用currentPage会限制增长
        if (this.orderList[type].currentPage - 1 === page && page < totalpage) {
          this.loading = true;
          this.requestOrderMessage(type);
        }
      }
    },
    getType(activeIndex) {
      this.secondMenu.active = activeIndex;
      this.secondMenu.activeType = ["pay", "go", "finished", "refund","toBeEvaluate","completeEvaluate"][
        activeIndex - 1
      ];
      const type = this.secondMenu.activeType;
      if (this.orderList[type].dataList.length === 0) {
        this.loading = true;
        this.requestOrderMessage(type);
      }
    },
  },
  mounted() {
    this.loading = true;
    //请求待支付页数据
    this.requestOrderMessage("pay");
  },
  created() {},
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
}
.second-menu {
  margin-top: 30px;
}
.second-menu >>> .el-step {
  cursor: pointer;
  /* justify-content: space-around; */
  /* width:10%; */
  /* margin: 0 auto; */
  /* display: ; */
  /* text-align: center; */
}
.second-menu >>> .el-step__head.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
}
.second-menu >>> .el-step__title.is-process {
  color: #c0c4cc;
  /* font-size: 16px; */
  font-weight: normal;
}
.content {
  width: 100%;
   /* display: flex;  */
    /* flex-wrap: wrap;  */
    /* justify-content: space-between; */
}
.list {
  cursor: pointer;
  width: 100%;
  padding: 20px;
  /* box-shadow: 0px 0px 6px #c7c6c6;
      border-radius: 2px; */
  margin-bottom: 20px;

  /* min-height: 1000px; */
}
.orderprice {
}
.red {
  display: inline-block;
  margin-right: 10px;
  color: #e73835;
}
.mount {
  font-size: 12px;
}
.date {
  color: #999999;
}
.evaluate {
  display: flex;
}
.evaluate > span {
  font-size: 15px;
  width: 80px;
  color: #666666;
  line-height: 20px;
}
.evaluate > span:nth-child(2) {
  text-align: right;
  border-left: 1px solid #999999;
}

.useractivity {
  width: 100%;
  min-height: 350px;
}
.useritem {
  display: flex;
  padding: 10px 10px 30px 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px #c7c6c6;
  margin-bottom: 16px;
}
/* .useritem > .title {
  width: 100%;
} */
.img {
  position: relative;
  width: 24%;
  height: 180px;
}
.act-img {
  width: 100%;
  height: 100%;
}
.user-price {
  position: absolute;
  z-index: 30;
  bottom: 14px;
  right: 16px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  padding: 4px 12px;
}
.user-right {
  width: 76%;
  position: relative;
  padding: 20px;
  /* box-sizing: border-box; */
}
.user-right .title {
  /* line-height: 1.5; */
  padding: 5px 0;
  display: block;
}
.toporder {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order {
  color: #666666;
}
.complete {
  color: #007741;
  border: 1px solid #007741;
  font-size: 14px;
  border-radius: 16px;
  padding: 4px 12px;
}
.act-title {
  /* font-weight: bold; */
  margin: 16px 0;

  display: flex;
  justify-content: space-between;
}
.act-title i {
  margin-right: 8px;
}
.userdescribe {
  margin-top: 20px;
  line-height: 24px;
  color: #999999;
}
.bottom-infos {
  /* width: 95%; */
  /* display: flex; */
  /* justify-content: space-between; */
  /* align-items: center; */
  display: inline-block;
  position: absolute;
  bottom: 10px;
  margin-bottom: -20px;
  right: 20px;
}
.bottom-infos > span {
  margin-left: 20px;
}
.icon-one {
  color: #323232;
  margin-right: 10px;
}
.icon-two {
  color: #323232;
}
.mores,
.delete {
  border-radius: 6px;
  padding: 9px 20px;
}
.mores {
  color: #ffffff;
  background: #007741;
}
.mores:hover {
  background: #069e5a;
}
.delete {
  color: #ffffff;
  background: #e73835;
}
.delete:hover {
  background: #f74835;
}
.my-dialog >>> .el-dialog__body {
  padding: 10px 0 30px 0;
  /* padding-bottom: 30px; */
}
.my-dialog .title {
  font-size: 22px;
  font-weight: bold;
  color: #069e5a;
}
.table .tr {
  display: flex;
  padding: 15px 0;
  align-items: center;
}
.table .th {
  padding: 12px 0;
  border-top: 3px solid #eeeeee;
  border-bottom: 3px solid #eeeeee;
  font-weight: bold;
}
.table .all-click {
  cursor: pointer;
}
.table .all-click:hover {
  color: #069e5a;
}
.table .isActive {
  color: #069e5a;
}
.table .tr .td {
  flex: 1;
}
.table .tr .status .box {
  border: 1px solid #069e5a;
  border-radius: 8px;
  padding: 4px 0;
  margin: 0 30px;
  color: #069e5a;
}
.table >>> .el-checkbox__inner:hover,
.table >>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #069e5a;
}
.table >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #069e5a;
  background-color: #069e5a;
}
/* .table >>> .el-dialog__close.el-icon:hover{
  color: #069e5a !important;
} */
.dialog-bottom > div {
  width: 120px;
  height: 36px;
  line-height: 36px;
  margin: 20px auto 0 auto;
  background-color: #007741;
  font-size: 18px;
  color: #ffffff;
  border-radius: 20px;
  cursor: pointer;
}
.dialog-bottom > div:hover {
  background: #069e5a;
}
.no-refund,
.no-refund:hover {
  background-color: #666666 !important;
  cursor: not-allowed;
}
.grey {
  color: #666666;
  border-color: #666666;
}
.right {
  /* width: 48%; */
  padding: 20px;
}
.title {
  font-weight: bold;
  margin: 20px 0;
}
.del-img {
  width: 100%;
  height: 400px;
}
.item {
  display: flex;
  align-items: center;
  color: #323232;
  margin-bottom: 42px;
}
.col {
  color: #5dba45;
}
.item:last-child {
  margin-bottom: 0px;
}
.text {
  display: block;
  margin-left: 20px;
}
.col-red {
  color: #e73835;
}
.evalute{
  padding: 10px 20px;
  position: relative;
}
.evalute >>> .el-upload-list{
  /* display: flex;
  flex-wrap: wrap; */
}
.top-wrapper{
  width: 100%;
  display: flex;
  background: #eee;
  padding: 5px;
}
.top-wrapper img{
  width: 80px;
  height: 60px;
}
.top-wrapper .title{
  width: 100%;
  color: #000;
  margin: 0 0 0 15px;
  font-size: 16px;
  text-align: left;
}
.evalute .item{
  margin-top:10px;
  display: flex;
  font-size: 16px;
}
.evalute .edit-wrapper,.evalute  .upload-wrapper{
  display: flex;
  width: 100%;
}
.evalute .footer-btn{
  /* position: absolute;
  right: 10px;
  bottom: 0; */
  margin: 0 auto;
  cursor: pointer;
  color: #ffffff;
  background: #007741;
  width: 80px;
  padding: 10px;
  font-size: 16px;
  border-radius: 10px;
}
.evalute .item .label{
  margin-right: 10px;
  width: 100px;
  text-align: right;
}
.evalute .item .score-wrapper{
  display: flex;
  flex: 1;
}
.evalute >>> .el-textarea{
  width: auto;
  flex: 1;
  font-size: 16px;
}
.evalute >>> .component-upload-image{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.evalute >>> .el-upload-list--picture-card .el-upload-list__item {
  width:70px;/*设置你想要的图片宽度*/
  height:70px;/*设置你想要的图片高度*/
  margin-bottom: 0px;
}
.evalute >>> .el-upload--picture-card{
  width:70px;/*设置你想要的图片宽度*/
  height:70px;/*设置你想要的图片高度*/
  line-height: 70px;
  margin-bottom: 0px;
}
.completed-evaluted-list .title{
  margin-left: 10px;
  margin: 0px 10px 10px 10px;
  padding-top: 0;
  position: relative;
} 
.completed-evaluted-list .depart-time{
  margin-left: 10px;
  /* margin-bottom: 10px; */
  padding-top: 0;
  position: relative;
} 

.completed-evaluted-list .useritem{
  display: flex;
  padding: 10px 10px 10px 10px;
  box-sizing: border-box;
  box-shadow: 0px 0px 6px #c7c6c6;
  margin-bottom: 16px;
  position: relative;
} 
.completed-evaluted-list .user-right{
 padding-top: 0;
} 
.completed-evaluted-list .text{
  font-size:16px;
  margin-left: 10px;
  margin-top: 10px;
} 
.completed-evaluted-list .comment-images-out{
  overflow-x: auto;
  padding-left:10px;
  margin-top: 10px;
} 
.completed-evaluted-list .act-title{
  position: absolute;
  bottom: 10px;
  right: 10px;
} 
.completed-evaluted-list .act-title-empty{
  height: 60px;
  width: 100%;
} 

.comment-images{
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
}
.comment-images img{
    margin: 10px 10px 10px 0;
    width: 70px;
    height: 70px;
    border-radius: 16px;
}
.completed-evaluted-list .seller-reply{
   font-size:28px;
   padding: 15px;
   margin-top: 10px;
   background: #F6F6F6;
   font-size: 16px;
   color:#ff7e00;
} 
.completed-evaluted-list .main{
  color:#333;
} 
.completed-evaluted-list .star-wrapper{
  display: flex;
  margin-left: 10px;
  margin-top: 10px;
}
.completed-evaluted-list .line-score,.completed-evaluted-list .leader-score{
  flex:1;
  display: flex;
  align-items: center;
}
.completed-evaluted-list .el-rate{
  position: relative;
  top: -5px;
}
.completed-evaluted-list .star-wrapper >>> .el-rate__icon{
        font-size: 28px;
        margin-left: 3px;
        margin-right: 3px;
    }
.completed-evaluted-list    .star-wrapper >>> .el-progress-bar__inner{
        font-size: 28px;
        margin-left: 3px;
        margin-right: 3px;
        background-color:'#FF7E00'
    }
</style>
<style>
.el-steps {
    justify-content: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/userview/activityOrder.vue